import React from 'react';
interface PriceDisplayProps {
  amount: number;
  originalAmount?: number;
  className?: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
}
export function PriceDisplay({
  amount,
  originalAmount,
  className = '',
  size = 'lg'
}: PriceDisplayProps) {
  const sizeClasses = {
    sm: 'text-lg',
    md: 'text-2xl',
    lg: 'text-4xl md:text-5xl',
    xl: 'text-5xl md:text-6xl'
  };
  return <span className={`font-heading font-bold ${className}`} data-id="element-197">
      {originalAmount && <span className="text-muted line-through text-lg md:text-2xl mr-3 font-body font-normal" data-id="element-198">
          ${Math.round(originalAmount)}
        </span>}
      <span className={`text-primary ${sizeClasses[size]}`} data-id="element-199">
        ${Math.round(amount)}
      </span>
    </span>;
}